<script setup>
import { computed } from 'vue';
const props = defineProps({ status: { type: String, default: 'unknown' } });
const statuses = ['active', 'inactive', 'maintenance', 'error'];
const normalizedStatus = computed(() => typeof props.status === 'string' ? props.status.trim().toLowerCase() : '');
</script>
<template><span class="status-badge" :class="statuses.includes(normalizedStatus) ? `status-${normalizedStatus}` : 'status-inactive'"><span class="status-dot" />{{ statuses.includes(normalizedStatus) ? $t(`devices.status.${normalizedStatus}`) : $t('common.unknown') }}</span></template>
